export const headerHeight = 120;
export const navPanelHeight = 60;
export const stickyHeaderHeight = 99;
export const sideDrawerMenuWidth = 150;
export const searchResultsOffset = 24;
